import React from "react";

export default function ProjectVisual({ kind, compact = false }) {
  return (
    <div
      className={`project-visual visual-${kind} ${compact ? "compact" : ""}`}
      aria-hidden="true"
    >
      <div className="visual-grid" />
      {kind === "code" ? (
        <div className="code-diagram">
          <div className="diagram-caption">STATEGEN / EXECUTION LOOP</div>
          <div className="code-line">
            <span>01</span> generate(state)
          </div>
          <div className="code-line">
            <span>02</span> execute(segment)
          </div>
          <div className="code-line">
            <span>03</span> verify(postconditions)
          </div>
          <div className="code-line accent-line">
            <span>04</span> recover → next state
          </div>
          <div className="diagram-foot">
            <span className="signal-dot" /> Semantic memory ↔ local recovery
          </div>
        </div>
      ) : kind === "sensor" ? (
        <div className="sensor-diagram">
          <div className="diagram-caption">HILLSAFE / SYSTEM CONCEPT</div>
          <svg viewBox="0 0 440 150" focusable="false">
            <path
              d="M0 130L75 73 140 103 235 26 320 94 385 56 440 103"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            />
            <path
              d="M0 145L75 93 140 123 235 46 320 114 385 76 440 123"
              fill="none"
              stroke="currentColor"
              opacity=".25"
            />
            <circle cx="235" cy="26" r="7" fill="currentColor" />
            <circle
              cx="235"
              cy="26"
              r="21"
              fill="none"
              stroke="currentColor"
              opacity=".3"
            />
          </svg>
          <div className="sensor-nodes">
            <span>STM32</span>
            <span>GSM / SMS</span>
            <span>Dashboard</span>
          </div>
        </div>
      ) : kind === "solar" ? (
        <div className="solar-diagram">
          <div className="diagram-caption">SOLAR / IMAGERY TO INSIGHT</div>
          <div className="solar-panels">
            {Array.from({ length: 12 }, (_, i) => (
              <span key={i} />
            ))}
          </div>
          <div className="diagram-foot">
            Imagery → features → infrastructure map
          </div>
        </div>
      ) : (
        <div className="robot-diagram">
          <div className="diagram-caption">
            ROBOT LEARNING / PHYSICAL INTERACTION
          </div>
          <svg viewBox="0 0 440 170" focusable="false">
            <path
              d="M50 145H120M85 145V105L150 45 220 90 265 88"
              stroke="currentColor"
              strokeWidth="13"
              fill="none"
              strokeLinejoin="round"
            />
            <circle
              cx="150"
              cy="45"
              r="12"
              fill="var(--surface)"
              stroke="currentColor"
              strokeWidth="4"
            />
            <circle
              cx="220"
              cy="90"
              r="10"
              fill="var(--surface)"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path d="M272 77v25" stroke="currentColor" strokeWidth="4" />
            <rect
              x="294"
              y="96"
              width="92"
              height="40"
              rx="9"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
            />
            <circle cx="312" cy="143" r="10" fill="currentColor" />
            <circle cx="369" cy="143" r="10" fill="currentColor" />
            <path d="M278 91h12" stroke="currentColor" strokeDasharray="3 3" />
          </svg>
          <div className="diagram-foot">
            Physical contact · No software connection
          </div>
        </div>
      )}
    </div>
  );
}
